// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"f00514f8","488":"b18f2d4b","520":"a1b97e9b","657":"80ebd2e4","721":"4c4e2dd5","914":"1c61c3b3"}[chunkId] + ".chunk.js";
};